import { ReportsComboPage } from "go-report-combo/User/pages";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { selectUser } from "go-security/services/users/selectors";
import { apiReport } from "../../../../../../services/Api/Report/apiReport";
import { CATALOG_TEMPLATE_LIST } from "./catalogs";

export const UserReportsComboPage = (props: RouteComponentProps) => {
	const { getReportsCustom, getTemplates } = apiReport;
	const user = useSelector(selectUser);

	const getTemplatesInternal = async () => {
		return CATALOG_TEMPLATE_LIST;
	};
	return (
		<ReportsComboPage
			{...props}
			getReportsCustom={getReportsCustom}
			getTemplates={getTemplatesInternal}
			user={user}
			segmentCRUDRedirectPath="/combo_reports"
			billOrdersRedirect="/group_reports/orders"
			billOrderItemRedirect="/group_reports/products"
		/>
	);
};
